import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "formik";
import { withRouter } from "react-router-dom";
import Delay from "../../util/Delay";
import PropertySection from "../property/PropertySection";
import SubmitButton from "../form/SubmitButton";
import SubmitFab from "../form/SubmitFab";
import memoAssign from "../../util/memoAssign";
import { Consumer as WorkflowConsumer } from "./context";

class WorkflowContent extends Component {
  shouldComponentUpdate = nextProps =>
    nextProps.formik.status !== this.props.formik.status ||
    nextProps.formik.errors !== this.props.formik.errors ||
    nextProps.formik.touched !== this.props.formik.touched ||
    nextProps.formik.values !== this.props.formik.values ||
    nextProps.formik.submitForm !== this.props.formik.submitForm ||
    nextProps.location !== this.props.location;

  render = () => {
    const {
      formik,
      history: {
        location: { pathname }
      }
    } = this.props;

    return (
      <WorkflowConsumer>
        {({
          getActiveStep,
          field,
          header,
          section,
          pathRoot,
          goBack,
          title,
          hideTitle,
          loading,
          j = 0
        }) => {
          const activeStep = getActiveStep();

          if (!activeStep && pathname !== pathRoot) {
            this.props.history.replace(pathRoot);
            return null;
          }

          const {
            header: formHeader = {},
            section: formSection = {},
            field: formField = {},
            sections,
            fieldInfo,
            hideButtons
          } = activeStep.form || {};

          const prev =
            activeStep.prev === undefined ? null : (
              <Button onClick={goBack(formik)} style={{ marginRight: "4px" }}>
                Back
              </Button>
            );

          const nextText = activeStep.next ? "Next" : "Submit";

          const next = this.props.noFab ? (
            <SubmitButton onClick={formik.submitForm} color="secondary">
              {nextText}
            </SubmitButton>
          ) : (
            <SubmitFab onClick={formik.submitForm} color="secondary">
              {nextText}
            </SubmitFab>
          );

          const buttons =
            hideButtons || (!prev && !next) ? null : (
              <Box pl={prev ? 0 : 1}>
                {prev}
                {next}
              </Box>
            );

          const form = !activeStep.form
            ? null
            : sections &&
              sections.map(
                ({
                  hidden,
                  box = {},
                  field: sectionField = {},
                  header: sectionHeader = {},
                  ...sectionEntry
                }) =>
                  hidden !== undefined &&
                  hidden(formik.values, formik) ? null : (
                    <PropertySection
                      disabled={activeStep.locked}
                      fieldInfo={fieldInfo}
                      {...sectionEntry}
                      header={memoAssign(header, formHeader, sectionHeader)}
                      field={memoAssign(field, formField, sectionField)}
                      section={memoAssign(section, formSection, box)}
                      key={j++}
                    />
                  )
              );

          const formTitle = !hideTitle && title && (
            <Box mb={2} ml={1}>
              <Typography variant="h5" color="primary">
                {title}
              </Typography>
            </Box>
          );

          return loading ? (
            <Delay wait={200}>
              <Modal open={loading}>
                <div />
              </Modal>
            </Delay>
          ) : (
            <Fade in>
              <Box>
                {formTitle}
                {form}
                {buttons}
              </Box>
            </Fade>
          );
        }}
      </WorkflowConsumer>
    );
  };
}

export default withRouter(
  connect(withStyles({}, { name: "LcWorkflowContent" })(WorkflowContent))
);
